var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.35 45.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed8b00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_11_1",
    "data-name": "Symbol 11 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.68,44a21,21,0,1,1,21-21A21,21,0,0,1,22.68,44Zm0-41a20,20,0,1,0,20,20A20,20,0,0,0,22.68,3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M27.65,22.58h-10a1.11,1.11,0,0,0-1.11,1.11v6.59a1.91,1.91,0,0,0,1.91,1.91h8.37a1.9,1.9,0,0,0,1.91-1.91h0V23.69a1.11,1.11,0,0,0-1.1-1.11h0m-3.58,7.14a.32.32,0,0,1-.23.39H21.57a.32.32,0,0,1-.32-.32.22.22,0,0,1,0-.08l.56-2.32a1.51,1.51,0,1,1,1.7-2.49,1.52,1.52,0,0,1,.39,2.1,1.61,1.61,0,0,1-.39.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "M27.64,21.82H25.49v-2.5a2.89,2.89,0,1,0-5.78,0v2.5H17.56v-2.5a5,5,0,0,1,10.08,0h0v2.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock_closed.0a388bb11147f2d21be7419c14a4d8df.svg";
export { ForwardRef as ReactComponent };